const SESSION_REFRESH_CODES = new Set([
  "AUTH_TOKEN_EXPIRED",
  "AUTH_TOKEN_INVALID",
  "AUTH_REQUIRED",
]);

export function isStunMSessionExpiry(payload) {
  const detail = payload?.detail ?? payload;
  // Older API deployments return text for the same first-party auth failures.
  // Do not classify arbitrary provider errors or subscriber/database failures.
  if (typeof detail === "string") {
    return /^(Authentication required|Could not validate credentials)[.!]?$/i.test(detail.trim()) ||
      /^Invalid token or subscriber: (Token has expired|Signature has expired\.?|Not enough segments|Signature verification failed\.?)$/i.test(detail.trim());
  }
  return Boolean(
    detail?.retryable === true && SESSION_REFRESH_CODES.has(detail?.code)
  );
}

export function shouldRefreshAxiosSession(error) {
  return (
    error?.response?.status === 401 &&
    isStunMSessionExpiry(error.response?.data)
  );
}

export async function shouldRefreshFetchSession(response) {
  if (response?.status !== 401) return false;
  try {
    return isStunMSessionExpiry(await response.clone().json());
  } catch (_) {
    return false;
  }
}
